import fallbackData from './data.json';

// In dev, use local data.json. In prod, fetch from S3.
// Set REACT_APP_DATA_URL in .env or environment to enable remote fetch.
const DATA_URL = process.env.REACT_APP_DATA_URL;

let cachedData = null;

export async function fetchEshopData() {
    if (cachedData) return cachedData;

    if (!DATA_URL) {
        // No remote URL configured - use static fallback (dev mode)
        cachedData = fallbackData;
        return cachedData;
    }

    try {
        const res = await fetch(DATA_URL, { cache: 'no-cache' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        cachedData = await res.json();
        return cachedData;
    } catch (err) {
        console.warn('Failed to fetch remote data, using fallback:', err);
        cachedData = fallbackData;
        return cachedData;
    }
}

// Synchronous getter for components that loaded after initial fetch
export function getEshopData() {
    return cachedData || fallbackData;
}
